import React from 'react';

import { EditOutline, Image } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { Box, Loader } from '@lyearn/ui';
import MediaContainer from '@/components/LegacyMediaContainer';
import { MediaContainerProps } from '@/components/LegacyMediaContainer/types';

import { circleStyle, editIconPos, mediaContainerMargin } from './styles';

interface ClickableProps {
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  isButton?: boolean;
}

export const Circle: React.FC<React.PropsWithChildren<ClickableProps>> = ({
  children,
  onClick,
  isButton,
}) => (
  <Box
    className={cn(
      'relative flex w-full cursor-pointer items-center justify-center rounded-full border border-dashed border-border-dark bg-bg-secondary',
      { 'cursor-pointer': !!onClick },
      { 'p-28': isButton },
      circleStyle,
    )}
    onClick={onClick}>
    {children}
  </Box>
);

export const MediaContainerComponent = (props: MediaContainerProps) => {
  if (props.medias?.length) {
    return (
      <Circle>
        <MediaContainer {...props} className={mediaContainerMargin} />
      </Circle>
    );
  }

  return null;
};

export const UploadButton = ({ onClick, mediaAvailable, isUploading }: any) => (
  <Circle isButton onClick={onClick}>
    {isUploading ? (
      <Loader className="text-text-primary" size={40} thickness={2} />
    ) : (
      <>
        <Image className="h-40 w-40 fill-current text-icon-placeholder" />
        <Box
          className={cn(
            'absolute flex h-40 w-40 items-center justify-center rounded-full bg-interactive-secondary',
            editIconPos,
          )}
          data-name="edit">
          <EditOutline className="h-20 w-20 fill-current text-icon-active" />
        </Box>
      </>
    )}
  </Circle>
);
